<template>
  <v-app-bar app clipped-left flat color="primary">
    <v-btn
      v-if="appBarOptions.leftButton === 'back-arrow'"
      @click="appBarOptions.funcLeftButton"
      text
      small
      class="px-0"
    >
      <v-icon color="white">mdi-keyboard-backspace</v-icon>
    </v-btn>

    <v-btn
      v-else-if="appBarOptions.leftButton === 'menu_seller'"
      @click="appBarOptions.funcLeftButton"
      text
      small
      class="px-0"
    >
      <v-icon color="white">mdi-home</v-icon>
    </v-btn>

    <v-img
      v-else-if="
        appBarOptions.leftButton &&
        appBarOptions.leftButton === 'list_seller' &&
        userDistributorId != '646d024a6e770f61219d2e3c'
      "
      fit
      max-width="130px"
      max-height="130px"
      :src="require('@/assets/img/logo_withe.png')"
    ></v-img>

    <v-img
      v-else-if="
        appBarOptions.leftButton &&
        appBarOptions.leftButton === 'list_seller' &&
        userDistributorId == '646d024a6e770f61219d2e3c'
      "
      contain
      max-width="200px"
      max-height="200px"
      :src="require('@/assets/img/agromich_logo_white.png')"
    ></v-img>

    <v-app-bar-nav-icon
      v-if="
        appBarOptions.leftButton === 'menu_seller' ||
        appBarOptions.leftButton === 'menu'
      "
      @click.stop="changeDrawer"
      color="white"
    />

    <!-- search field-->
    <v-text-field
      v-if="isOpenSearch && currentPath === '/areasList'"
      v-model="searchArea"
      autofocus
      :placeholder="translations.search"
      class="pl-2 pt-4 searchField"
      color="#fff"
      dark
    >
    </v-text-field>

    <!-- route name -->
    <p v-if="!isOpenSearch" class="white--text pl-2 pt-4">
      {{ currentRoute }}
    </p>

    <v-spacer></v-spacer>

    <v-text-field
      v-if="
        isOpenSearchSeller &&
        (currentPath === '/seller-list/client/' ||
          currentPath === '/seller-list/prospect/')
      "
      v-model="searchSeller"
      :placeholder="translations.search"
      class="pl-2 pt-4 searchField"
      color="#fff"
      autofocus
      dark
    >
    </v-text-field>
    <!-- right buttons -->
    <v-btn
      v-if="
        appBarOptions.rightButton &&
        appBarOptions.rightButton === 'listAreas' &&
        isAddSoilSample
      "
      text
      small
      class="px-0"
      @click="closeDrawUI(false)"
    >
      <v-icon color="white">mdi-close</v-icon>
    </v-btn>
    <v-btn
      v-if="
        appBarOptions.rightButton &&
        appBarOptions.rightButton === 'listAreas' &&
        !isAddSoilSample &&
        shoudShow
      "
      text
      @click="isDrawSoilArea(true)"
      class="px-0"
    >
      <v-icon color="white">mdi-plus-box-multiple</v-icon>
    </v-btn>
    <v-btn
      v-if="
        appBarOptions.rightButton &&
        appBarOptions.rightButton === 'listAreas' &&
        !isAddSoilSample
      "
      text
      @click="listTerritories"
      class="px-0"
    >
      <v-icon color="white">mdi-format-list-bulleted</v-icon>
    </v-btn>

    <v-btn
      v-if="appBarOptions.rightButton && appBarOptions.rightButton === 'save'"
      text
      small
      class="px-0"
      @click="appBarOptions.funcRightButton"
    >
      <v-icon color="white">mdi-content-save</v-icon>
    </v-btn>

    <v-btn
      v-if="appBarOptions.rightButton && appBarOptions.rightButton === 'close'"
      text
      small
      class="px-0"
      @click="appBarOptions.funcRightButton"
    >
      <v-icon color="white">mdi-close</v-icon>
    </v-btn>

    <v-btn
      v-if="appBarOptions.rightButton && appBarOptions.rightButton === 'search'"
      text
      @click="openSearch"
      class="px-0"
    >
      <v-icon color="white" v-if="!isOpenSearch">mdi-magnify</v-icon>
      <v-icon v-else color="white">mdi-close</v-icon>
    </v-btn>

    <v-btn
      v-if="
        appBarOptions.rightButton &&
        (appBarOptions.rightButton === 'search_seller' ||
          appBarOptions.rightButton === 'search_prospect')
      "
      text
      @click="openSearchSeller"
      class="px-0"
    >
      <v-icon color="white" v-if="!isOpenSearchSeller">mdi-magnify</v-icon>
      <v-icon v-else color="white">mdi-close</v-icon>
    </v-btn>
    <v-btn
      text
      dark
      v-if="
        appBarOptions.rightButton &&
        appBarOptions.rightButton === 'search_prospect' &&
        user.role != 'ADMIN_SAMPLER'
      "
      class="mx-1"
      @click="goToForm"
    >
      <v-icon> mdi-account-plus </v-icon>
    </v-btn>
    <v-btn
      text
      dark
      v-if="
        appBarOptions.rightButton &&
        appBarOptions.likeButton &&
        appBarOptions.openLikeButton
      "
      class="mx-1"
      @click="appBarOptions.openLikeButton"
    >
      <v-icon> mdi-thumb-up </v-icon>
    </v-btn>
    <v-menu
      transition="slide-y-transition"
      bottom
      v-if="
        appBarOptions.rightButton &&
        (appBarOptions.rightButton === 'search_seller' ||
          appBarOptions.rightButton === 'search_prospect')
      "
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" text class="px-0">
          <v-icon color="white">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="(item, i) in menuSeller" :key="i">
          <v-list-item-title @click="actionMenuSeller(item.value)">{{
            item.text
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu
      transition="slide-y-transition"
      bottom
      v-if="
        appBarOptions.rightButton &&
        appBarOptions.rightButton === 'profit_detail_acceptable'
      "
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" text class="px-0">
          <v-icon color="white">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="(item, i) in menu" :key="i">
          <v-list-item-title @click="actionDetailProfit(item.value)">{{
            item.name
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-menu
      transition="slide-y-transition"
      bottom
      v-if="
        appBarOptions.rightButton &&
        appBarOptions.rightButton === 'profit_detail'
      "
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" text class="px-0">
          <v-icon color="white">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="(item, i) in menu2" :key="i">
          <v-list-item-title @click="actionDetailProfit(item.value)">{{
            item.name
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn
      v-if="
        appBarOptions.rightButton && appBarOptions.rightButton === 'profit_add'
      "
      text
      @click="addProfit"
      class="px-0"
    >
      <v-icon color="white">mdi-plus-box-multiple</v-icon>
    </v-btn>
    <v-btn
      v-if="
        appBarOptions.rightButton && appBarOptions.rightButton === 'proyect_add'
      "
      text
      @click="addProject"
      class="px-0"
    >
      <v-icon color="white">mdi-plus-box-multiple</v-icon>
    </v-btn>

    <v-dialog v-model="dialogLogOut" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6">
          {{ translations.label_confirmation }}
        </v-card-title>
        <v-card-text>{{ translations.label_logout_confirmation }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogLogOut = false">
            {{ translations.cancel }}
          </v-btn>
          <v-btn color="green darken-1" text @click="logOut">
            {{ translations.accept }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ChangeLanguageModal
      v-model="showChangeLanguageModal"
      v-if="showChangeLanguageModal"
    />
  </v-app-bar>
</template>

<script>
import ChangeLanguageModal from "@/components/home/modals/ChangeLanguageModal.vue";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
  components: {
    ChangeLanguageModal,
  },
  data() {
    return {
      user: null,
      currentRoute: "",
      currentPath: "",
      isAreaSelected: false,
      drawer: false,
      dialogLogOut: false,
      isOpenSearch: false,
      isOpenSearchSeller: false,
      shoudShow: true,
      searchSeller: "",
      searchArea: "",
      menu: [
        // { name: "Aceptado por el cliente", value: "accepted" },
        { name: "Descargar PDF", value: "pdf" },
      ],
      menu2: [{ name: "Descargar PDF", value: "pdf" }],
      menuSeller: [
        { text: "Cerrar sesión", value: "logout" },
        { text: "Descargar app muestreo", value: "app" },
      ],
      showChangeLanguageModal: false,
      userDistributorId: null,
    };
  },
  watch: {
    $route(to, from) {
      this.currentRoute = this.$route.name;
      this.currentPath = this.$route.path;
      if (this.currentPath === "/territory") {
        this.isOpenSearch = false;
        this.isAreaSelected = true;
      }
    },
    searchArea(value) {
      this.SEARCH_AREA(value.toLowerCase());
    },
    searchSeller(value) {
      this.SEARCH_SELLER(value);
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.user.role != "ORG_USER" && this.user.role != "ORG_USER_ADMIN") {
      this.userDistributorId = localStorage.getItem(
        "distributionOrganizationId"
      );
    }
    if (this.user.role == "SAMPLER_SOLENA") {
      this.menuSeller = [
        { text: this.translations.menu_log_out, value: "logout" },
        {
          text: this.translations.home_menu_label_change_dis,
          value: "change_distributor",
        },
        { text: this.translations.download_sampling_app, value: "app" },
        { text: this.translations.change_language, value: "change_language" },
      ];
    } else {
      this.menuSeller = [
        { text: this.translations.menu_log_out, value: "logout" },

        { text: this.translations.download_sampling_app, value: "app" },
        { text: this.translations.change_language, value: "change_language" },
      ];
    }
    this.menu = [
      // { name: this.translations.label_client_accept, value: "accepted" },
      { name: this.translations.label_download_pdf, value: "pdf" },
    ];
    this.menu2 = [{ name: this.translations.label_download_pdf, value: "pdf" }];
    if (this.user.role == "ORG_USER") {
      this.shoudShow = false;
    }
    // this.currentRoute = this.$route.name;
    this.currentPath = this.$route.path;
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("logs", ["log_selected"]),
    ...mapState(["appBarOptions"]),
    ...mapState("areasList", ["isAddSoilSample", "isRedraw", "areaRedraw"]),
  },
  methods: {
    ...mapMutations("areasList", [
      "SEARCH_AREA",
      "SET_ADD_AREA",
      "SET_AREA_REDRAW",
      "SET_REDRAW",
      "SET_AREA_SELECTED",
    ]),
    ...mapMutations("user", ["SEARCH_SELLER", "SET_CHANGE_DISTRIBUTOR"]),
    ...mapMutations("profit", ["SET_ACTION"]),
    ...mapMutations(["SET_LOADER"]),
    ...mapMutations(["SET_APPBAR_OPTIONS"]),
    ...mapMutations("profile", ["SET_PROFILE"]),
    ...mapMutations("samples", [
      "SET_SAMPLE_SELECTED",
      "SET_SAMPLES",
      "SET_AREA_SELECTED_SAMPLE",
    ]),
    ...mapMutations("logs", ["CLEAR_STATE"]),
    ...mapMutations("areasList", ["SET_AREA_SELECTED"]),
    ...mapActions("session", ["logout", "getNewToken"]),
    changeDrawer() {
      this.$emit("drawer", !this.drawer);
    },
    listTerritories() {
      this.$router.push(`/areasList`);
      this.searchArea = "";
    },
    goBack() {
      this.$router.go(-1);
    },
    openSearch() {
      this.isOpenSearch = !this.isOpenSearch;
      if (this.isOpenSearch) {
      } else {
        this.searchArea = "";
        this.SEARCH_AREA(null);
      }
    },
    openSearchSeller() {
      this.isOpenSearchSeller = !this.isOpenSearchSeller;
      if (this.isOpenSearchSeller) {
      } else {
        this.searchSeller = "";
        this.SEARCH_SELLER(null);
      }
    },
    isDrawSoilArea(value) {
      this.SET_ADD_AREA(value);
    },
    addProfit() {
      this.$router.push(`/profit-form`);
    },
    addProject() {
      this.$router.push(`/proyect-form`);
    },
    closeDrawUI(value) {
      this.SET_ADD_AREA(value);
      if (this.isRedraw) {
        this.SET_REDRAW(value);
      }
    },
    actionDetailProfit(value) {
      this.SET_ACTION(value);
    },
    async actionMenuSeller(value) {
      if (value === "logout") {
        this.dialogLogOut = true;
      }

      if (value === "app") {
        window.open(
          "https://play.google.com/store/apps/details?id=com.solena.app_comercial_android&hl=es_MX",
          "_blank"
        );
      }
      if (value === "change_distributor") {
        this.SET_CHANGE_DISTRIBUTOR(true);
      }
      if (value == "change_language") {
        this.showChangeLanguageModal = true;
      }
    },
    async logOut() {
      await this.logout();
      await this.clear();
      this.$router.push("/login");
    },
    async clear() {
      this.SET_SAMPLE_SELECTED(null);
      this.CLEAR_STATE();
      this.SET_SAMPLES([]);
      this.SET_AREA_SELECTED_SAMPLE(null);
      this.SET_AREA_SELECTED(null);
    },
    goToForm() {
      this.$router.push("/prospect-new-form");
    },
  },
  updated() {
    // console.log("PATH", this.$route.path);
    if (this.$route.path.includes("/client-form/")) {
      this.currentRoute = this.translations.label_update_client;
    }
    if (this.$route.path.includes("/prospect-new-form")) {
      this.currentRoute = this.translations.label_new_farm;
    }
    if (this.$route.path.includes("/prospect-update-form")) {
      this.currentRoute = this.translations.label_update_prospect;
    }
    if (this.$route.path.includes("/territory")) {
      this.currentRoute = this.translations.label_territory;
    }
    if (this.$route.path.includes("/agronomic-management")) {
      this.currentRoute = this.translations.label_agronomic_management;
    }
    if (this.$route.path.includes("/areasList")) {
      this.currentRoute = this.translations.label_territory_list;
    }
    if (this.$route.path.includes("/sampling-end/")) {
      this.currentRoute = this.translations.label_finish_sampling;
    }
    if (this.$route.path == "/samples") {
      this.currentRoute = this.translations.label_samples_list;
    } else {
      if (this.$route.path.includes("/samples/")) {
        this.currentRoute = this.translations.menu_samples;
      }
    }
    if (this.$route.path.includes("/sample-detail/")) {
      this.currentRoute = this.translations.label_sample_detail;
    }
    if (this.$route.path.includes("/result-list")) {
      this.currentRoute = this.translations.label_analysis_results;
    }
    if (this.$route.path.includes("/result-detail")) {
      this.currentRoute = this.translations.label_analysis_detail;
    }
    if (this.$route.path.includes("/analysis-list")) {
      this.currentRoute = this.translations.label_analysis_results;
    }
    if (this.$route.path.includes("/proyects-list")) {
      this.currentRoute = this.translations.label_projects;
    }
    if (this.$route.path === "/proyect-form") {
      this.currentRoute = this.translations.label_create_project;
    } else {
      if (this.$route.path.includes("/proyect-form/")) {
        this.currentRoute = this.translations.label_update_project;
      }
    }
    if (this.$route.path.includes("/proyect-detail/")) {
      this.currentRoute = this.translations.label_project_detail;
    }
    if (this.$route.path.includes("/profile")) {
      this.currentRoute = this.translations.label_profile;
    }
    if (this.$route.path.includes("/samples-not-geo")) {
      this.currentRoute = this.translations.label_new_sample;
    }
    if (this.$route.path.includes("/profit-list")) {
      this.currentRoute = this.translations.label_profitability;
    }
    if (this.$route.path.includes("/sample-guide")) {
      this.currentRoute = this.translations.request_guide_title;
    }
  },
};
</script>

<style scoped>
.searchField {
  width: -webkit-fill-available;
  color: transparent;
  margin-left: 7px;
}
</style>
